<template>
  <div class="page-frame">
    <van-notice-bar> 当前订单已被拆分成{{logistics.packageNum}}个包裹，{{logistics.sendNum}}个已发出</van-notice-bar>
    <section v-for="(data, idx) in logistics.packageList" :key="idx">
      <div class="package-card">
        <div class="header" @click="goLogistics(idx)">
          <div class="pack-index">
            {{'包裹' + (idx + 1)}}
          </div>
          <div class="budget">
            {{logStatsMap[data.logisticsResp.expressStatus]}}
          </div>
          <div class="express-no">
            {{data.logisticsResp.expressComName}} {{data.logisticsResp.expressNo}}
          </div>
          
          <van-icon name="arrow" class="icon" />
        </div>
        <div class="logistic-resp" v-if="data.logisticsTraceRespList && data.logisticsTraceRespList.length">
          {{data.logisticsTraceRespList[0].content}}
        </div>
        <div class="product-list" v-if="data.logisticsOrderItemRespDTOList && data.logisticsOrderItemRespDTOList.length">
          <div class="product-item" v-for="item,key in data.logisticsOrderItemRespDTOList" :key="key">
            <img :src="item.itemPicUrl" alt="">
            <div class="num">共{{item.deliveryNum}}件</div>
          </div>
        </div>
      </div>

      <!-- <van-cell @click="goLogistics(idx)" :value="" isLink></van-cell> -->
      <!-- 审计合规需求 -->
      <!-- <div class="logistics bg-white ">
        <p>物流号：{{ data.nu }}</p>
        <p>
          {{ data.data[0].context }}
        </p>
        <p class="time van-hairline--bottom">
          {{ data.data[0].ftime }}
        </p>
      </div> -->
      <!-- <ul class="list bg-white">
        <li v-for="(item, index) in data.orderDetails" :key="index">
          <van-image class="image van-hairline--surround" :src="item.mainImg"></van-image>

          x{{ item.itemNum }}
        </li>
      </ul>

      <p class="sum">共{{ data.totalItemNum }}件商品</p> -->
    </section>
  </div>
</template>

<script>
import { logStatsMap } from '@/constant/enum'
export default {
  data() {
    return {
      logStatsMap,
      logistics: {
        packageList: []
      }
    };
  },

  async created() {
    const { id } = this.$route.params;
    // const { expressUrl } = this.$route.query;
    this.logistics = await this.$fetch.getOrderExpressList({
      orderId: id,
    });
 
  },

  methods: {
    goLogistics(index) {
      const { expressUrl, isFromZyyd } = this.$route.query;
      this.$router.push({
        path: `/logistics/${this.$route.params.id}`,
        query: {
          index
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page-frame {
  height: 100%;
  width: 100%;
  background: @background-color-light;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  .page-main.flex-1 {
    -webkit-overflow-scrolling: touch;
    overflow: auto;
  }
}
section {
  margin-top: 12px;
  .package-card {
    margin: 0 12px 12px;
    padding: 16px 12px;
    border-radius: 8px;
    background: #fff;
    .header {
      height: 20px;
      display: flex;
      align-items: center;
      .pack-index {
        font-weight: 500;
        color: #262626;
        font-size: 14px;
        margin-right: 6px;
      }
      .budget {
        margin-right: auto;
        padding: 2px;
        background: #1E8DFF;
        border-radius: 2px;
        font-size: 10px;
        color: #fff;
      }
      .express-no {
        color: #8C8C8C;
        font-size: 12px;
      }
      .icon {
        position: relative;
        top: 2px;
        left: 4px;
        color: #8C8C8C;
      }
    }
    .logistic-resp {
      font-size: 12px;
      font-weight: 400;
      color: #262626;
      line-height: 18px;
      padding: 10px 0 0;
    }
    .product-list {
      margin: 24px 0 8px;
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      .product-item {
        width: 76px;
        height: 76px;
        background: rgba(0, 0, 0, 0.02);
        border-radius: 4px;
        margin-right: 6px;
        position: relative;
       
        img {
          border-radius: 4px ;
           width: 76px;
            height: 76px;
        }
        .num {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 76px;
          height: 14px;
          line-height: 14px;
          font-size: 10px;
          text-align: center;
          color: #8C8C8C;
          background: rgba(0, 0, 0, 0.04);
          border-radius: 0 0 4px 4px;
        }
      }
    }
  }
}
</style>
